import * as React from 'react';
import { Modal, ModalFooter, ModalHeader } from 'reactstrap';
import { getValue } from '@utils/lodash';
import DocumentSvgComponent from '@assets/svg-components/document';

interface IGuidelinesPopupProps {
  isOpen: boolean;
  handleModal: () => void;
  guidelines: string;
}

const GuidelinesPopup = (props: IGuidelinesPopupProps) => {
  return (
    <Modal
      isOpen={getValue(props, `isOpen`, false)}
      toggle={props.handleModal}
      size="lg"
    >
      <ModalHeader style={{ background: '#f8f8fd' }} toggle={props.handleModal}>
        <div className="d-flex align-items-center w-100">
          <DocumentSvgComponent size={24} color={'#FD9933'} />
          <h6 className="header_text__18 ms-2 mb-0">Business Expense Guidelines</h6>
        </div>
      </ModalHeader>
      <div className="m-4" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        <style dangerouslySetInnerHTML={{ __html: `
          .guidelines-content ul {
            list-style-type: disc !important;
            padding-left: 24px !important;
            margin-top: 8px !important;
            margin-bottom: 8px !important;
          }
          .guidelines-content ol {
            list-style-type: decimal !important;
            padding-left: 24px !important;
            margin-top: 8px !important;
            margin-bottom: 8px !important;
          }
          .guidelines-content li {
            list-style: inherit !important;
            margin-bottom: 8px !important;
            display: list-item !important;
          }
          .guidelines-content ul li {
            list-style-type: disc !important;
          }
          .guidelines-content ol li {
            list-style-type: decimal !important;
          }
          .guidelines-content > *:first-child {
            text-align: center !important;
          }
          .guidelines-content .text-align-left, .guidelines-content .text-align--left {
            text-align: left !important;
          }
          .guidelines-content .text-align-center, .guidelines-content .text-align--center {
            text-align: center !important;
          }
          .guidelines-content .text-align-right, .guidelines-content .text-align--right {
            text-align: right !important;
          }
          .guidelines-content .text-align-justify, .guidelines-content .text-align--justify {
            text-align: justify !important;
          }
        `}} />
        <div
          className="guidelines-content"
          dangerouslySetInnerHTML={{ __html: getValue(props, `guidelines`, '') }}
        />
      </div>
      <ModalFooter>
        <div className="delete-popup-wrapper__cta-wrapper">
          <button
            onClick={props.handleModal}
            className="delete-popup-wrapper__cta-btn delete-popup-wrapper__cta-btn--secondary"
          >
            Close
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default GuidelinesPopup;
